import {
  DashboardOutlined,
  TeamOutlined,
  DollarOutlined,
  NotificationOutlined,
  LoginOutlined,
  ExceptionOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  BarChartOutlined,
} from "@ant-design/icons-vue";

const ADMIN_HASH = import.meta.env.VITE_ADMIN_HASH;

export const adminRoutes = [
  {
    path: "/zyoric/ops",
    redirect: `/internal/ops/${ADMIN_HASH}/ops-dashboard`,
  },
  {
    path: `/internal/ops/${ADMIN_HASH}`,
    component: () => import("@/layouts/AdminLayout.vue"),
    meta: { requiresAdmin: true, hideLayout: true },
    children: [
      { path: "", redirect: "ops-dashboard" },
      {
        path: "ops-dashboard",
        component: () => import("@/views/admin/Dashboard.vue"),
        name: "OpsDashboard",
        meta: { hideLayout: true },
        icon: DashboardOutlined,
      },
      {
        path: "ops-conversion-stats",
        component: () => import("@/views/admin/ConversionStats.vue"),
        name: "OpsConversionStats",
        meta: { hideLayout: true },
        icon: BarChartOutlined,
      },
      {
        path: "ops-users",
        component: () => import("@/views/admin/Users.vue"),
        name: "OpsUsers",
        meta: { hideLayout: true },
        icon: TeamOutlined,
      },
      {
        path: "ops-plans",
        component: () => import("@/views/admin/Plans.vue"),
        name: "OpsPlans",
        meta: { hideLayout: true },
        icon: DollarOutlined,
      },
      {
        path: "ops-tickets",
        component: () => import("@/views/admin/Tickets.vue"),
        name: "OpsTickets",
        meta: { hideLayout: true },
        icon: FileSearchOutlined,
      },
      {
        path: "ops-error-logs",
        component: () => import("@/views/admin/ErrorLogs.vue"),
        name: "OpsErrorLogs",
        meta: { hideLayout: true },
        icon: ExceptionOutlined,
      },
      {
        path: "/ops-action-logs",
        component: () => import("@/views/admin/ActionLogs.vue"),
        name: "OpsActionLogs",
        meta: { hideLayout: true },
        icon: HistoryOutlined,
      },
      {
        path: "ops-notifications",
        component: () => import("@/views/admin/Notifications.vue"),
        name: "OpsNotifications",
        meta: { hideLayout: true },
        icon: NotificationOutlined,
      },
      {
        path: "forbidden",
        component: () => import("@/views/admin/403.vue"),
        name: "OpsForbidden",
        meta: { hideLayout: true },
      },
    ],
  },
  // 将登录路由提取为独立路由，使其可以通过完整路径访问
  {
    path: `/internal/ops/${ADMIN_HASH}/ops-login`,
    component: () => import("@/views/admin/Login.vue"),
    name: "OpsLogin",
    meta: { hideLayout: true },
    icon: LoginOutlined,
  },
];
